import { render, staticRenderFns } from "./RelatorioFaturamento.vue?vue&type=template&id=2d21b6ab"
import script from "./RelatorioFaturamento.vue?vue&type=script&lang=js"
export * from "./RelatorioFaturamento.vue?vue&type=script&lang=js"
import style0 from "./RelatorioFaturamento.vue?vue&type=style&index=0&id=2d21b6ab&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d21b6ab')) {
      api.createRecord('2d21b6ab', component.options)
    } else {
      api.reload('2d21b6ab', component.options)
    }
    module.hot.accept("./RelatorioFaturamento.vue?vue&type=template&id=2d21b6ab", function () {
      api.rerender('2d21b6ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/RelatorioFaturamento.vue"
export default component.exports